import { createRoot } from "react-dom/client";
import "./styles.css";
import { App } from "./App";
import { AuthGate } from "./AuthGate";
import { applyTweaksToDocument, parseStoredTweaks, TWEAK_STORAGE_KEY } from "./app/tweaks";

// Tema salvato applicato prima del login: senza, la schermata di accesso
// restava chiara anche con il tema scuro scelto.
try {
  applyTweaksToDocument(parseStoredTweaks(localStorage.getItem(TWEAK_STORAGE_KEY)));
} catch {
  /* Senza storage resta il tema chiaro di index.html. */
}

const root = createRoot(document.getElementById("root")!);
root.render(
  <AuthGate>
    <App />
  </AuthGate>
);
